import { Fleet } from '@src/main/modules/parameters/domain/fleet-positions/fleet.interface';
import { PositionEntity } from '@src/main/modules/parameters/infrastructure/entity/position.entity';

export interface FleetEntity {
  description: string;
  fleet: string;
  fleetId: string;
  positions: PositionEntity[];
}

export function toFleet(entity: FleetEntity): Fleet {
  return {
    ...entity,
  };
}

export function fromFleet(model: Fleet): FleetEntity {
  return {
    ...model,
  };
}
